import { useQuery } from "@tanstack/react-query";
import * as api from "../../api/client";
import type { ApiCtx } from "../../api/client";
import { useUi } from "../../state/ui";
import { downloadAllAsZip } from "../../files/download";
import { toast } from "../../notify";
import { texte } from "../../texte";

/** Datei-Tree im Rail, nur unter dem gerade geöffneten Arbeitsbereich (client.md §11). */
export function RailFileTree({ ctx }: { ctx: ApiCtx }) {
  const openDoc = useUi((s) => s.openDoc);
  const openFile = useUi((s) => s.openFile);
  const query = useQuery({
    queryKey: ["files", ctx.apiUrl, ctx.token, ctx.workspace],
    queryFn: () => api.files(ctx),
  });
  const docs = query.data?.documents ?? [];

  async function handleDownloadAll() {
    try {
      const n = await downloadAllAsZip(ctx);
      toast(texte.fileView.downloaded, `${n} Dokumente als ${ctx.workspace}.zip heruntergeladen.`, true);
    } catch (e) {
      toast(texte.errors.generic, e instanceof Error ? e.message : String(e));
    }
  }

  return (
    <div className="rail-tree">
      {docs.length === 0 ? (
        <div className="empty-hint">{texte.rail.noDocuments}</div>
      ) : (
        docs.map((d) => (
          <button
            key={d.doc_id}
            className={`file${openDoc === d.doc_id ? " active" : ""}`}
            onClick={() => openFile(d.doc_id)}
          >
            <span className="ico">📄</span>
            <span className="name">{d.doc_id}</span>
          </button>
        ))
      )}
      {docs.length > 0 && (
        <button className="dl-all" onClick={handleDownloadAll}>
          {texte.rail.downloadAll}
        </button>
      )}
    </div>
  );
}
